import { useEffect, useRef, useState } from "react";

// How many lines of the current move have landed.
//
// A geomantic figure is made one line at a time, so that is how it arrives:
// the cast lays down sixteen lines — four Mothers, four lines each, in the
// order they were made — and every move after it lays down four. The beat is
// just a counter, and every figure on the shield reads its own state off it.
//
// REDUCED MOTION GOES STRAIGHT TO THE END. It does not skip the arrival, it
// skips the travel: the same rule the Tree's sequences and the tarot deal
// follow. The figures are all there, at once, and nothing moves.
export const CAST_BEATS = 16;
export const STEP_BEATS = 4;

export function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export default function useBeat(total, { interval = 150, enabled = true, key = 0 }) {
  const reduced = prefersReducedMotion();
  const [beat, setBeat] = useState(enabled && !reduced ? 0 : total);
  const timer = useRef(null);

  useEffect(() => {
    if (timer.current) window.clearInterval(timer.current);
    if (!enabled || reduced) {
      setBeat(total);
      return undefined;
    }

    setBeat(0);
    timer.current = window.setInterval(() => {
      setBeat((was) => {
        if (was >= total) {
          window.clearInterval(timer.current);
          timer.current = null;
          return was;
        }
        return was + 1;
      });
    }, interval);

    return () => {
      if (timer.current) window.clearInterval(timer.current);
      timer.current = null;
    };
    // `key` is what restarts it: the same move re-entered should animate again.
  }, [total, interval, enabled, reduced, key]);

  return { beat, done: beat >= total, reduced };
}
